import { OLModal } from "components/Tooltips/OLModal";
import { useMessage } from "hooks/intl";
import { useState } from "react";
import { Attribute } from "./AttributesDetails";
import { ComplexAttribute } from "./ComplexAttribute";
import { useStyles } from "./styles";
import { countObject } from "./utils";

interface Props {
  attribute: {
    name: string;
    value: string | number | Attribute | Attribute[];
  };
}

export const AttributeDetails = ({ attribute }: Props) => {
  const [isOpen, setIsOpen] = useState(false);
  const { message } = useMessage();
  const classes = useStyles();
  const isComplexAttribute = typeof attribute.value === "object";
  const objectCount = countObject(attribute.value);

  return (
    <>
      <OLModal
        open={isOpen}
        onClose={() => setIsOpen(false)}
        modalWidth={700}
        submitText={message({ id: "close" })}
        submitAction={() => {
          setIsOpen(false);
        }}
        header={message({ id: "attributes" })}
      >
        <ComplexAttribute attribute={attribute} />
      </OLModal>
      <div
        className={classes.chips}
        onClick={isComplexAttribute ? () => setIsOpen(true) : undefined}
      >
        {attribute.name}
        {!isComplexAttribute ? (
          `: ${attribute.value}`
        ) : (
          <div className={classes.objectsCount}>{objectCount}</div>
        )}
      </div>
    </>
  );
};
